import React, { useEffect } from "react";
import ReactDOM from "react-dom";

function Modal({ isOpen, children, className = "", fullScreen = false }) {
	const body = document.getElementById("body-wrapper");
	useEffect(() => {
		if (!isOpen) return;
		body?.classList.add("modal-open");
		return () => body?.classList.remove("modal-open");
	}, [isOpen, body]);
	if (!isOpen) {
		return null;
	}

	const containerClasses = `Modal__container ${className} ${fullScreen ? "Modal__full-screen" : ""}`;

	return ReactDOM.createPortal(
		<div className="Modal">
			<div className={containerClasses}>{children}</div>
		</div>,
		document.getElementById("modal")
	);
}

export default Modal;
